import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';

@Component({
    selector: 'app-no-match',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './no-match.component.html',
})
export class NoMatchComponent {
    @Input() isBRPNoMatchFlow: boolean = false;
    @Input() caseId: any;
    constructor(private router: Router, private applicationService: ApplicationService) {}

    ngOnInit(){
        if(this.isBRPNoMatchFlow){
            let obj = {
                caseId: this.caseId,
                isFATDSCase: true
            };
            this.applicationService
            .submission(obj)
            .subscribe({
                next: (res) => {
                },
                error: (err) => {
                },
            });
        }
    }

    goToHome() {
        this.router.navigate(['']);
    }
}
